import styled from 'styled-components';

const WrapAcctionButton = styled.div`
  .ant-btn:first-child {
    margin-right: 10px;
  }
`;

const WrapEditWindow = styled.div``;

const innerDrawerBodyStyle = {
  padding: "5px"
};

export { WrapAcctionButton, WrapEditWindow, innerDrawerBodyStyle };



// WEBPACK FOOTER //
// ./src/components/editor/editor.styled.ts